const hasPublishedMedia = (participant) => participant.trackPublications.size > 0;
export const isJoined = (participant) => {
    if (!participant.metadata) {
        return hasPublishedMedia(participant);
    }
    try {
        const meta = JSON.parse(participant.metadata);
        if (meta.joined === false) {
            return false;
        }
        return meta.joined === true || hasPublishedMedia(participant);
    }
    catch (error) {
        console.warn(`Failed to parse metadata for participant ${participant.identity}`, error);
        return hasPublishedMedia(participant);
    }
};
/**
 * Whether we should subscribe to a remote participant's tracks.
 * Prefer media presence over metadata — after rejoin, publications may appear
 * before metadata is parsed, and stale joined:false must not hide a live publisher.
 */
export const shouldSubscribeToRemote = (participant) => {
    if (participant.isLocal) {
        return false;
    }
    if (hasPublishedMedia(participant)) {
        return true;
    }
    return isJoined(participant);
};
